<template>
  <div class="content">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <h1 class="title">
            <app-cells :indent="false">
              <span>Transfer (ID: {{ this.$route.params.id }})</span>
            </app-cells>
          </h1>
          <div class="status-title" :class="[`status-title--${ transfer.status.code }`]">
            {{ transfer.status.name }}
          </div>
          <template v-if="is_general_manager || is_product_storage_supervisor">
            Checked: <app-switcher v-model="transfer.checked" @change="onChangeTransfer" />
          </template>
        </app-cells>
        <app-button v-if="transfer.status.code === 'draft'" @click.native="onShowDeleteModal(null)" theme="error">
          Delete
        </app-button>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Date:</span>
              <span>{{ dateFormat(transfer.date) }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Storekeeper:</span>
              <router-link
                v-if="is_general_manager"
                :to="{ name: 'employees-profile', params: { id: transfer.storekeeper.id } }"
                class="info-cards__link"
              >
                {{ transfer.storekeeper.full_name }}
              </router-link>
              <span v-else>{{ transfer.storekeeper.full_name }}</span>
            </div>
          </div>
          <div v-if="transfer.employee" class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Taken by:</span>
              <router-link
                v-if="is_general_manager"
                :to="{ name: 'employees-profile', params: { id: transfer.employee.id } }"
                class="info-cards__link"
              >
                {{ transfer.employee.full_name }}
              </router-link>
              <span v-else>{{ transfer.employee.full_name }}</span>
            </div>
          </div>
          <div v-if="transfer.mountain_crew" class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Taken by:</span>
<!--              <router-link-->
<!--                v-if="is_general_manager"-->
<!--                :to="{ name: 'climbing-mountain-crew-detail', params: { id: transfer.mountain_crew.id } }"-->
<!--                class="info-cards__link"-->
<!--              >-->
<!--                {{ transfer.mountain_crew.full_name }}-->
<!--              </router-link>-->
              <span>{{ transfer.mountain_crew.full_name }}</span>
            </div>
          </div>
          <div v-if="!transfer.employee && !transfer.mountain_crew" class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Taken by:</span>
              <span>-</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <button
              v-if="is_general_manager || is_product_storage_supervisor"
              @click="onShowModalEditResponsible"
              class="info-cards__control"
          >
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Responsible center:</span> <span>{{ transfer.responsible_center ? transfer.responsible_center.name : '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Department:</span> <span>{{ transfer.responsible_center_department ? transfer.responsible_center_department.name : '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Total value:</span><span>{{ transfer.products_amount ? transfer.products_amount.toLocaleString() : 0 }} TSh</span>
          </div>
        </div>
        <div class="info-cards__card">
          <button @click="onShowModalEditTransport" class="info-cards__control">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Transport:</span> <span>{{ transfer.transport ? transfer.transport.name : '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Quantity:</span>
            <span>{{ transfer.transport_qty || 0 }}</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Cost:</span>
            <span>{{ transfer.transport_cost ? `${transfer.transport_cost.toLocaleString()}` : 0 }} TSh</span>
          </div>
        </div>
      </div>
      <app-cells>
        <app-textarea
          v-model="transfer.note"
          rows="5"
          @change.native="onUpdateNotes"
          placeholder="Write a notes"
          :readonly="transfer.status.code === 'completed'"
        />
      </app-cells>
      <v-client-table
          :data="table.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
      >
        <template #h__product><div class="table-default__left">Product name</div></template>
        <template #count="{ row, index }">
          {{ transfer.status.code === 'completed' ? index : index !== table.items.length ? index : '' }}
        </template>
        <template #product="{ row, index }">
          <router-link
              v-if="transfer.status.code === 'completed' || (transfer.status.code !== 'completed' && index !== table.items.length)"
              :to="{ name: 'product-storage-products-detail', params: { id: row.product.id } }"
              class="table-default__link-border"
          >
            {{ row.product.name }}
          </router-link>
          <app-select
            v-if="transfer.status.code !== 'completed' && index === table.items.length"
            @option:selected="onNewProductChange"
            v-model="new_row"
            :options="products_options"
            :clearable="false"
            :calculate-position="withPopper"
            :append-to-body="true"
            placeholder="Enter product name"
            class="select--in-table"
            ref="new_product"
            :tabindex="1"
          />
        </template>
        <template #product.measurement.name="{ row, index }">
          {{ transfer.status.code === 'completed' ? row.product.measurement.name : index !== table.items.length ? row.product.measurement.name : new_row ? new_row.measurement.name : '' }}
        </template>
        <template #price="{ row, index }">
          {{ transfer.status.code === 'completed' ? `${row.price.toLocaleString()} TSh` : index !== table.items.length ? `${row.price.toLocaleString()} TSh` : new_row ? `${new_row.price.toLocaleString()} TSh` : '' }}
        </template>
        <template #product.in_stock="{ row, index }">
          {{ transfer.status.code === 'completed' ? new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.product.in_stock) : index !== table.items.length ? new Intl.NumberFormat('ru-RU').format(row.product.in_stock) : new_row ? new Intl.NumberFormat('ru-RU').format(new_row.in_stock) : '' }}
        </template>
        <template #quantity="{ row, index }">
          <input
              v-if="transfer.status.code !== 'completed' && index !== table.items.length"
              v-model.number="row.quantity"
              class="input input--300"
              @change="updateTableData(row, { quantity: row.quantity })"
              type="number"
              style="text-align: center"
              :class="{ 'input--error': +row.quantity > +row.product.in_stock }"
          />
          <input
              v-if="transfer.status.code !== 'completed' && index === table.items.length && new_row"
              @keydown.enter="onNewRowSubmit"
              v-model.number="new_row.quantity"
              class="input input--300"
              type="number"
              style="text-align: center"
              ref="new_qty"
              :tabindex="2"
          />
          <template v-if="transfer.status.code === 'completed'">
            {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.quantity) }}
          </template>
        </template>
        <template #amount="{ row, index }">
          {{ transfer.status.code === 'completed' ? `${row.amount.toLocaleString()} TSh` : index !== table.items.length ? `${row.amount.toLocaleString()} TSh` : '' }}
        </template>
        <template #controls="{ row, index }">
          <div v-if="transfer.status.code !== 'completed' && index !== table.items.length" class="table-default__controls">
            <button @click="onShowDeleteModal(row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="end">
        <app-button v-if="transfer.status.code === 'completed' && is_general_manager" @click.native="onShowModalUpdate('reverted')" theme="error">
          Revert
        </app-button>
        <app-button v-if="transfer.status.code === 'completed'" @click.native="onPrint" theme="warn" ref="print">
          Print transfer
        </app-button>
        <app-button v-else @click.native="onShowModalUpdate('completed')">Complete</app-button>
      </app-cells>
    </template>
    <modal
        name="transfer-update"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('transfer-update')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          {{ update_status === 'reverted' ? 'Revert transfer' : 'Update transfer' }}
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to {{ update_status === 'reverted' ? 'revert' : 'complete' }} transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('transfer-update')" theme="dark">Cancel</app-button>
            <app-button @click.native="onChangeTransferStatus" ref="status_changed">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideDeleteModal" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete {{ product_to_delete ? 'product' : 'transfer' }}
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to do that?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onHideDeleteModal" theme="dark">Cancel</app-button>
            <app-button v-if="product_to_delete" @click.native="onDeleteProduct" ref="delete">Yes</app-button>
            <app-button v-else @click.native="onDeleteTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="transport-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('transport-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Updating transport</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm('form')">
            <app-form-group label="Transport" required>
              <app-select
                v-model="form.transport"
                :reduce="item => item.code"
                :options="transport_type_options"
                :clearable="false"
                placeholder="Transport"
                :error="$v.form.transport.$error"
              />
              <template #error>
                <div v-if="$v.form.transport.$dirty && !$v.form.transport.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Quantity" label-for="transport_qty" required>
              <app-input
                v-model.number="form.transport_qty"
                placeholder="Quantity"
                type="number"
                min="0"
                id="transport_qty"
                name="transport_qty"
                :error="$v.form.transport_qty.$error"
              />
              <template #error>
                <div v-if="$v.form.transport_qty.$dirty && !$v.form.transport_qty.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Cost" label-for="transport_cost" required>
              <app-input
                v-model.number="form.transport_cost"
                placeholder="Cost"
                type="number"
                min="0"
                id="transport_cost"
                name="transport_cost"
                :error="$v.form.transport_cost.$error"
              />
              <template #error>
                <div v-if="$v.form.transport_cost.$dirty && !$v.form.transport_cost.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center">
              <app-button type="submit" ref="transport">Update</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="responsible-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('responsible-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Updating responsible</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm('responsible_form')">
            <app-form-group label="Responsible center" required>
              <app-select
                @input="onSelectResponsibleCenter"
                v-model="responsible_form.responsible_center"
                :options="responsible_center_options"
                :clearable="false"
                placeholder="Responsible center"
                :error="$v.responsible_form.responsible_center.$error"
              />
              <template #error>
                <div v-if="$v.responsible_form.responsible_center.$dirty && !$v.responsible_form.responsible_center.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Department" required>
              <app-select
                v-model="responsible_form.responsible_center_department"
                :options="responsible_center_departments_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Department"
                :readonly="!responsible_form.responsible_center"
                :error="$v.responsible_form.responsible_center_department.$error"
              />
              <template #error>
                <div v-if="$v.responsible_form.responsible_center_department.$dirty && !$v.responsible_form.responsible_center_department.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center">
              <app-button type="submit" ref="responsible">Update</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteProductStorageTransfer,
  deleteProductstorageTransferProduct,
  getProductsProductstorage,
  getProductStorageResponsibleCenter,
  getProductStorageTransfer,
  getProductStorageTransferProductList,
  getProductStorageTransportType,
  getTransferPrint,
  patchProductStorageTransfer,
  patchProductStorageTransferProduct,
  postProductstorageTransferProduct,
} from '@/http'
import { format, parse } from 'date-fns'
import { createPopper } from '@popperjs/core'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ProductStorageTransfersDetail',
  data() {
    return {
      is_loaded: false,
      transfer: null,
      table: {
        items: [],
        columns: [
          'count',
          'product',
          'product.measurement.name',
          'price',
          'product.in_stock',
          'quantity',
          'amount',
          'controls'
        ],
        options: {
          headings: {
            'count': '#',
            'product': 'Product name',
            'product.measurement.name': 'Unit',
            'price': 'Price',
            'product.in_stock': 'Curr. Stock',
            'quantity': 'Qty',
            'amount': 'Total value',
            'controls': ''
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      new_row: null,
      products_options: [],
      placement: 'bottom',
      product_to_delete: null,
      form: {},
      transport_type_options: [],
      responsible_form: {},
      responsible_center_options: [],
      responsible_center_departments_options: [],
      update_status: '',
    }
  },
  validations: {
    form: {
      transport_qty: { required },
      transport_cost: { required },
      transport: { required },
    },
    responsible_form: {
      responsible_center: { required },
      responsible_center_department: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_product_storage_supervisor() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_supervisor')
    },
  },
  created() {
    document.title = `Transfer (ID: ${ this.$route.params.id }) | Altezza Board`
    this.getTransferData()
    getProductStorageTransportType().then(response => { this.transport_type_options = response.data })
    getProductStorageResponsibleCenter().then(response => { this.responsible_center_options = response.data })
  },
  methods: {
    onShowModalUpdate(status) {
      this.update_status = status
      this.$modal.show('transfer-update')
    },
    getTransferData() {
      getProductStorageTransfer(this.$route.params.id).then(res => {
        this.transfer = res.data
        getProductsProductstorage().then(res => { this.products_options = res.data })
        getProductStorageTransferProductList(this.$route.params.id).then(res => {
          this.table.items = res.data
          if (this.transfer.status.code !== 'completed') this.table.items.push({})
          this.is_loaded = true
        })
      })
    },
    onShowModalEditTransport() {
      this.form = {
        transport: this.transfer.transport ? this.transfer.transport.code : null,
        transport_qty: this.transfer.transport_qty || 0,
        transport_cost: this.transfer.transport_cost || 0,
      }
      this.$modal.show('transport-modal')
    },
    onShowModalEditResponsible() {
      this.responsible_form = {
        responsible_center: this.transfer.responsible_center,
        responsible_center_department: this.transfer.responsible_center_department.code,
      }
      this.responsible_center_departments_options = this.responsible_form.responsible_center.departments
      this.$modal.show('responsible-modal')
    },
    onSelectResponsibleCenter() {
      this.responsible_center_departments_options = this.responsible_form.responsible_center.departments
      if (this.responsible_form.responsible_center.departments.length === 1) this.responsible_form.responsible_center_department = this.responsible_form.responsible_center.departments[0].code
      else this.responsible_form.responsible_center_department = null
    },
    onCheckForm(form_field) {
      this.$v[form_field].$touch()
      if (this.$v[form_field].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        if (form_field === 'responsible_form') this.sendResponsibleForm()
        else this.sendForm()
      }
    },
    sendForm() {
      this.$refs.transport.preload = true
      patchProductStorageTransfer(this.$route.params.id, this.form)
        .then(() => {
          this.getTransferData()
          this.$notify({
            type: 'success',
            title: 'Transport updated',
          })
          this.$modal.hide('transport-modal')
        })
        .catch(() => {
          this.$refs.transport.preload = false
        })
    },
    sendResponsibleForm() {
      this.$refs.responsible.preload = true
      const data = {...this.responsible_form}
      data.responsible_center = data.responsible_center.code
      patchProductStorageTransfer(this.$route.params.id, data)
        .then(() => {
          this.getTransferData()
          this.$notify({
            type: 'success',
            title: 'Responsible updated',
          })
          this.$modal.hide('responsible-modal')
        })
        .catch(() => {
          this.$refs.responsible.preload = false
        })
    },
    onPrint() {
      this.$refs.print.preload = true
      getTransferPrint(this.$route.params.id)
        .finally(() => { this.$refs.print.preload = false })
        .then(response => { window.open(response.data) })
    },
    onUpdateNotes() {
      patchProductStorageTransfer(this.$route.params.id, { note: this.transfer.note })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Notes saved',
          })
        })
    },
    onChangeTransfer() {
      patchProductStorageTransfer(this.$route.params.id, { checked: this.transfer.checked })
    },
    onChangeTransferStatus() {
      this.$refs.status_changed.preload = true
      patchProductStorageTransfer(this.$route.params.id, { status: this.update_status })
        .finally(() => {
          this.$refs.status_changed.preload = false
          this.$modal.hide('transfer-update')
        })
        .then(() => {
          getProductStorageTransfer(this.$route.params.id).then(res => {
            this.transfer = res.data
            if (this.transfer.status.code === 'completed') this.table.items.pop()
            this.$notify({
              type: 'success',
              title: 'Status changed',
            })
          })
        })
    },
    onNewRowSubmit() {
      if (this.new_row.quantity && this.new_row.id) {
        if (this.new_row.quantity <= +this.new_row.in_stock) {
          postProductstorageTransferProduct(
            this.$route.params.id,
            {
              product: this.new_row.id,
              quantity: this.new_row.quantity,
            }
          )
            .then(res => {
              getProductStorageTransfer(this.$route.params.id).then(res => {
                this.transfer = res.data
              })
              this.table.items = res.data
              this.table.items.push({})
              this.new_row = null
              this.$nextTick(() => {
                this.$refs.new_product.$el.querySelector('input').focus()
              })
              this.$notify({
                type: 'success',
                title: 'Product added',
              })
            })
        } else {
          this.$notify({
            type: 'error',
            title: 'The quantity of the item must be less than the current stock',
          })
        }
      } else {
        this.$notify({
          type: 'info',
          title: 'Check that the table row fields are filled in correctly',
        })
      }
    },
    updateTableData(row, data) {
      if (row.quantity <= row.product.in_stock) {
        patchProductStorageTransferProduct(this.$route.params.id, row.id, data)
          .then(res => {
            this.table.items = res.data
            if (this.transfer.status.code !== 'completed') this.table.items.push({})
            getProductStorageTransfer(this.$route.params.id).then(res => {
              this.transfer = res.data
            })
          })
      } else {
        this.$notify({
          type: 'error',
          title: 'The quantity of the item must be less than the current stock',
        })
      }
    },
    onNewProductChange () {
      this.$nextTick(() => { this.$refs.new_qty.focus() })
    },
    onShowDeleteModal(id) {
      if (id) this.product_to_delete = id
      this.$modal.show('delete-modal')
    },
    onHideDeleteModal() {
      this.product_to_delete = null
      this.$modal.hide('delete-modal')
    },
    onDeleteProduct() {
      this.$refs.delete.preload = true
      deleteProductstorageTransferProduct(this.$route.params.id, this.product_to_delete)
        .finally(() => {
          this.$refs.delete.preload = false
        })
        .then(res => {
          this.table.items = res.data
          this.table.items.push({})
          this.new_row = null
          getProductStorageTransfer(this.$route.params.id).then(res => {
            this.transfer = res.data
          })
          this.$notify({
            type: 'success',
            title: 'Product deleted',
          })
          this.onHideDeleteModal()
        })
    },
    onDeleteTransfer() {
      this.$refs.delete.preload = true
      deleteProductStorageTransfer(this.$route.params.id)
        .finally(() => { this.$refs.delete.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer deleted',
          })
          this.$router.push({ name: 'product-storage-transfers-active' })
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    withPopper (dropdownList, component, {width}) {
      dropdownList.style.width = width
      createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 0],
              adaptive: true
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          },
        ]
      })
    }
  }
}
</script>
